module.exports = __webpack_public_path__ + "img/y_p3_scene.64c71abf.svg";